import React from "react";
import {FaCreditCard} from 'react-icons/fa'

const extraSublinks = [
    {
        label:'Web development',
        icons:<FaCreditCard/>,
        subMenus:[
            {
                category:'React.JS'
            },
            {
                category:'Node.JS'
            },
            {
                category:'CSS'
            },
            {
                category:'HTML 5'
            },
            {
                category:'Angular'
            },
            {
                category:'TypeScript'
            },
            {
                category:'ASP.NET Core'
            }
        ]
    },
    {
        label:'Mobile development',
  
        subMenus:[
            {
                category:'Google Flutter'
            },
            {
                category:'React Native'
            },
            {
                category:'IOS Development'
            },
            {
                category:'Dart (Programming Language)'
            },
            {
                category:'Swift'
            },
            {
                category:'Swift UI'
            },
            {
                category:'Kotlin'
            }
        ]
    },
    {
        label:'Game development',
        subMenus:[
            {
                category:'Unity'
            },
            {
                category:'Unreal'
            },
            {
                category:'Game Development Fundamentals'
            },
            {
                category:'C#'
            },
            {
                category:'3D Game Development'
            },
            {
                category:'C++'
            },
            {
                category:'Godot'
            },
        ]
    },
    {
        label:'Entrepreneurship',
        subMenus:[
            {
                category:'Business Fundamentals'
            },
            {
                category:'Entrepreneurship Fundamentals'
            },
            {
                category:'Freelance'
            },
            {
                category:'Startup'
            },
            {
                category:'Online Business'
            },
            {
                category:'Business Strategy'
            },
            {
                category:'Business Plan'
            },
            {
                category:'Blogging'
            },
            {
                category:'ChatGPT'
            },
       
        ]
    },
    {
        label:'Graphic Design',
        subMenus:[
            {
                category:'Photoshop'
            },
            {
                category:'Adobe Illustrator'
            },
            {
                category:'Canva'
            },
            {
                category:'Drawing'
            },
            {
                category:'Digital Painting'
            },
            {
                category:'InDesign'
            },
        ]
    },

    {
        label:'IT Certifications',
        subMenus:[
            {
                category:'AWS'
            },
            {
                category:'COMPTIA++'
            },
            {
                category:'Amazon AWS' 
            },
            {
                category:'COMPTIA A+ Security'
            },
            {
                category:'Cisco CCNA'
            },
            {
                category:'Microsoft AZ-900'
            },
            {
                category:'Information Security'
            },
        ]
    },
    {
        label:'Business Analytics',
        subMenus:[
            {
                category:'Microsft Power BI'
            },
            {
                category:'SQL'
            },
            {
                category:'Data Modelling' 
            },
            {
                category:'Business Analysis'
            },
            {
                category:'Data Analysis'
            },
            {
                category:'Data Warehouse'
            },
            {
                category:'DAX'
            },
        ]
    },
    {
        label:'Digital Marketing',
        subMenus:[
            {
                category:'Social Media'
            },
            {
                category:'Marketing Strategies'
            },
            {
                category:'Google Analytics' 
            },
            {
                category:'Copy Writing'
            },
            {
                category:'Startups'
            },
            {
                category:'Internet Marketing'
            },
            {
                category:'Email Marketing'
            },
        ]
    },
    {
        label:'Personnal Transformation',
        subMenus:[
            {
                category:'Life Coaching'
            },
            {
                category:'Personal Development'
            },
            {
                category:'Personnal Transformation' 
            },
            {
                category:'Sound Therapy'
            },
            {
                category:'Life Purpose'
            },
            {
                category:'Mindfulness'
            },
            {
                category:'Emotional Intelligence'
            },
        ]
    },
    {
        label:'All Categories',
        subMenus:[
            {
                category:'Development'
            },
            {
                category:'Music'
            },
            {
                category:'Business' 
            },
            {
                category:'Finance & Accounting'
            },
            {
                category:'Personal Development'
            },
            {
                category:'Design'
            },
            {
                category:'Marketing'
            },
            {
                category:'Lifestyle'
            },
            {
                category:'Health & Fitness'
            },
        ]
    },
    {
        label:'Get your team access to over',
   
      
    },
    {
        label:'19, 000 to Udemy Courses,',

    },
    {
        label:'anytime, anywhere.',
      
  
    },
    {
        label:'Turn what you know into an',
      
  
    },
    {
        label:'opportunity and reach',
      
  
    },
    {
        label:'millions around the world',
      
  
    }


]

export default extraSublinks